import { createContext, useContext } from 'react';
import { RootStore } from 'store/rootStore';
import { ProposalItemsStore } from 'store/ui-stores/proposal-v2/proposalItemsStore';
import ProductLineDelegate from 'store/modules/proposal/delegates/productLineDelegate';
import ProposalPageStore from './pageStore';

type ProposalPageDelegate = ProductLineDelegate<ProposalPageStore>;

export const ProductLineDelegateContext = createContext<ProposalPageDelegate>(
  new ProductLineDelegate(new ProposalPageStore(new ProposalItemsStore(new RootStore())), null),
);

export function useProductLineDelegate(): ProposalPageDelegate {
  return useContext(ProductLineDelegateContext);
}
